"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResetPassword = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reduxForm = require("redux-form");

var _auth = require("../../redux/modules/auth");

var _resetPasswordValidator = require("./resetPasswordValidator");

var _resetPasswordValidator2 = _interopRequireDefault(_resetPasswordValidator);

var _ResetPasswordForm = require("../../components/password/ResetPasswordForm");

var _ResetPasswordForm2 = _interopRequireDefault(_ResetPasswordForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPassword = exports.ResetPassword = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ResetPassword, _Component);

  function ResetPassword() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResetPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResetPassword.__proto__ || (0, _getPrototypeOf2.default)(ResetPassword)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (values) {
      _this.props.resetPassword(values);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResetPassword, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Uusi Salasana" }),
        _react2.default.createElement(
          "h1",
          { className: "h3" },
          "Uusi salasana"
        ),
        _react2.default.createElement(_ResetPasswordForm2.default, {
          fields: this.props.fields,
          handleSubmit: this.props.handleSubmit,
          onSubmit: this.submit,
          auth: this.props.auth
        })
      );
    }
  }]);
  return ResetPassword;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  resetPassword: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object.isRequired
}, _temp2);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}, {
  resetPassword: _auth.resetPassword
})((0, _reduxForm.reduxForm)({
  form: "resetPassword",
  fields: ["email"],
  validate: _resetPasswordValidator2.default
})(ResetPassword));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Password/ResetPassword.js
 ** module id = 1225
 ** module chunks = 0
 **/